import { useEffect, useRef } from "react";
/**
 * Causes focus to return to where it last was when
 * a popper is re-opened before it fully closes
 * */
export const useRestoreFocusOnReopen = ({ motionState, isEnabled, positionerRef }) => {
    const lastFocusedElementRef = useRef(null);
    const lastMotionStateRef = useRef();
    useEffect(() => {
        const positioner = positionerRef.current;
        const isReopening = motionState === "opening" && lastMotionStateRef.current === "closing";
        // Skip if disabled or overlay not mounted
        if (!isEnabled || !positioner) {
            lastMotionStateRef.current = motionState;
            lastFocusedElementRef.current = null;
            return;
        }
        // Restore focus to last focused element (when opening after closing)
        if (isReopening) {
            lastFocusedElementRef.current?.focus({ preventScroll: true });
        }
        // Save last motion state
        lastMotionStateRef.current = motionState;
        // Track and store focus within overlay (while open)
        if (motionState === "opened") {
            lastFocusedElementRef.current = document.activeElement;
            const handleFocus = (e) => {
                lastFocusedElementRef.current = e.target;
            };
            positioner.addEventListener("focus", handleFocus, true);
            return () => {
                positioner.removeEventListener("focus", handleFocus, true);
            };
        }
        return () => { };
    }, [motionState, isEnabled, positionerRef]);
};
